import { InjectedConnector } from '@web3-react/injected-connector'
import { toast } from 'react-toastify'
const injected = new InjectedConnector({ supportedChainIds: [56, 97] })

injected.on('Web3ReactDeactivate', () => {
  window.localStorage.removeItem('userData')
  toast.warn('Disconnect form metamask', {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
})
export default injected